import { GridColDef } from "@mui/x-data-grid";

export const referralTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
